var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.70463L15.75 10.4546V15.1875C15.75 15.6351 15.5722 16.0643 15.2557 16.3807C14.9393 16.6972 14.5101 16.875 14.0625 16.875H3.9375C3.48995 16.875 3.06072 16.6972 2.74426 16.3807C2.42779 16.0643 2.25 15.6351 2.25 15.1875V10.4546L9 3.70463ZM14.625 2.8125V6.75L12.375 4.5V2.8125C12.375 2.66332 12.4343 2.52024 12.5398 2.41475C12.6452 2.30926 12.7883 2.25 12.9375 2.25H14.0625C14.2117 2.25 14.3548 2.30926 14.4602 2.41475C14.5657 2.52024 14.625 2.66332 14.625 2.8125Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2046 1.68729C8.41557 1.47639 8.70167 1.35791 8.99998 1.35791C9.29829 1.35791 9.58438 1.47639 9.79535 1.68729L17.2732 9.16404C17.3789 9.26967 17.4382 9.41292 17.4382 9.56229C17.4382 9.71167 17.3789 9.85492 17.2732 9.96055C17.1676 10.0662 17.0244 10.1255 16.875 10.1255C16.7256 10.1255 16.5823 10.0662 16.4767 9.96055L8.99998 2.48267L1.52323 9.96055C1.41761 10.0662 1.27435 10.1255 1.12498 10.1255C0.975605 10.1255 0.832351 10.0662 0.726728 9.96055C0.621106 9.85492 0.561768 9.71167 0.561768 9.56229C0.561768 9.41292 0.621106 9.26967 0.726728 9.16404L8.2046 1.68729Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOrange);
export default __webpack_public_path__ + "static/media/HomeOrange.bd971bc3533c25d92c25a1ec901147c3.svg";
export { ForwardRef as ReactComponent };